const state = {
    formData: {},
  }
  const mutations = {
    //添加搜索后的数据
    addData(state, data) {
        state.formData = data 
    },
    //删除数据
    delData(state,) {
        state.formData = {}
    },
    
  }
  
  export default {
    namespaced: true,
    state,
    mutations
  }
  